import type { StringGUID } from "@pdfking/tfunc"

import type { PdfEngineOptions } from "../../engine/PdfEngineOptions"

export type TaskBase = {
  readonly task_id: StringGUID
  readonly options: PdfEngineOptions
}
